(function(){
    'use strict'

    angular.module('app.perfilesAsiento')
    .factory('PerfilesAsientoService', PerfilesAsientoService);

    PerfilesAsientoService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function PerfilesAsientoService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getAllPerfil: getAllPerfil,
            getByIdPerfil: getByIdPerfil,
            savePerfil: savePerfil,
            updatePerfil:updatePerfil,
            removePerfil: removePerfil,
            getAllPerfilDetalle: getAllPerfilDetalle,
            savePerfilDetalle: savePerfilDetalle,
            updatePerfilDetalle:updatePerfilDetalle,
            removePerfilDetalle: removePerfilDetalle
        };

        return api;

        function getAllPerfil(){

            var url = apiSettings.apiBaseUrl + 'api/perfiles-asiento/perfil/' + UserInfoService.getCompaniaId();
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getByIdPerfil(perfilId){

            var url = apiSettings.apiBaseUrl + 'api/perfiles-asiento/perfil/' + UserInfoService.getCompaniaId() + '/' + perfilId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function savePerfil(perfil){

            perfil.id = 0;

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/perfiles-asiento/perfil',  
                method: 'POST',  
                data: perfil
            });  
            return response;
        };

        function updatePerfil(perfil){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/perfiles-asiento/perfil',  
                method: 'PUT',  
                data: perfil
            });  
            return response;
        };

        function removePerfil(perfil){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/perfiles-asiento/perfil',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: perfil
            });  
            return response;
        };

        //Detalles

        function getAllPerfilDetalle(perfilId){

            var url = apiSettings.apiBaseUrl + 'api/perfiles-asiento/detalle/' + UserInfoService.getCompaniaId() + '/' + perfilId;
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function savePerfilDetalle(detalle){

            detalle.id = 0;

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/perfiles-asiento/detalle',  
                method: 'POST',  
                data: detalle
            });  
            return response;
        };

        function updatePerfilDetalle(detalle){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/perfiles-asiento/detalle',  
                method: 'PUT',  
                data: detalle
            });  
            return response;
        };

        function removePerfilDetalle(detalle){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/perfiles-asiento/detalle',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: detalle
            });  
            return response;
        };

    };

})();